import Choices from 'choices.js'

import "choices.js/public/assets/styles/choices.min.css"

function activatePickMany () {
  const element = document.querySelector('select.pick-many');
  if (element) {
    new Choices(element, {
      removeItemButton: true,
      searchEnabled: false
    });
  }
}

$(document).ready(function() {
  activatePickMany()
});
